import { render } from "./BuildhomeIcon.vue?vue&type=template&id=7a404796&scoped=true"
import script from "./BuildhomeIcon.vue?vue&type=script&lang=js"
export * from "./BuildhomeIcon.vue?vue&type=script&lang=js"

import "./BuildhomeIcon.vue?vue&type=style&index=0&id=7a404796&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a404796"]])

export default __exports__